<template>
  <div class="" :style="{ height: contentHeight + 'px' }">
    <!-- <iframe name="my-iframe" id="my-iframe" src="https://www.baidu.com" frameborder="0" width="100%" height="100%" scrolling="yes"></iframe> -->
    <iframe
      id="template-iframe"
      ref="iframe"
      :src="src"
      @load="loaded"
      frameborder="0" width="100%" height="100%" scrolling="yes"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "help",
  data() {
    return {
      iframeWin: {},
    };
  },
  created(){

  },
  computed: {
    contentHeight() {
      return document.documentElement.clientHeight - 50;
    },
    src() {
      // return window.helpURL;
      return "http://www.baidu.com";
    },
  },
  methods: {
    loaded() {
       const cookie = document.cookie;
      //  console.log("cookie="+JSON.stringify(cookie));
       this.iframeWin.postMessage(cookie, this.src);
    },
  },
  mounted() {
    this.iframeWin = this.$refs.iframe.contentWindow;
  },
};
</script>

<style scoped>
</style>
